export default __webpack_public_path__ + "static/media/Hoshizaki@3x.3f8189ba.png";